/* ==========================================================
   WM Ingredient Focus - wm-ingredient-focus.js
   Version: 1.0.0
   ========================================================== */

(function () {
  'use strict';

  const SECTION_TYPE = 'wm-ingredient-focus';
  const SELECTOR = '[data-section-type="' + SECTION_TYPE + '"]';

  function getItemData(item) {
    const template = item.querySelector('[data-wm-ingredient-template]');
    const source = template && template.content ? template.content : item;
    const title = source.querySelector('[data-wm-ingredient-title]');
    const dosage = source.querySelector('[data-wm-ingredient-dosage]');
    const description = source.querySelector('[data-wm-ingredient-description]');

    return {
      title: title ? title.textContent.trim() : '',
      dosage: dosage ? dosage.textContent.trim() : '',
      description: description ? description.innerHTML : ''
    };
  }

  function init(root) {
    if (root.dataset.wmInit === 'true') return;
    root.dataset.wmInit = 'true';

    const items = Array.from(root.querySelectorAll('[data-wm-ingredient-item]'));
    const detail = root.querySelector('[data-wm-ingredient-detail]');
    const detailIndex = root.querySelector('[data-wm-detail-index]');
    const detailTitle = root.querySelector('[data-wm-detail-title]');
    const detailDosage = root.querySelector('[data-wm-detail-dosage]');
    const detailDescription = root.querySelector('[data-wm-detail-description]');
    const handlers = [];

    if (!items.length || !detail) {
      if (detail) detail.hidden = true;
      root.wmIngredientFocusHandlers = handlers;
      return;
    }

    detail.hidden = false;

    function activate(activeIndex, moveFocus) {
      items.forEach(function (item, index) {
        const trigger = item.querySelector('[data-wm-ingredient-trigger]');
        const active = index === activeIndex;
        item.classList.toggle('is-active', active);
        if (trigger) {
          trigger.setAttribute('aria-selected', active ? 'true' : 'false');
          trigger.setAttribute('tabindex', active ? '0' : '-1');
          trigger.setAttribute('aria-controls', detail.id);
          if (active && moveFocus) trigger.focus();
        }
      });

      const activeItem = items[activeIndex];
      const data = getItemData(activeItem);

      if (detailIndex) detailIndex.textContent = String(activeIndex + 1).padStart(2, '0');
      if (detailTitle) detailTitle.textContent = data.title;
      if (detailDosage) detailDosage.textContent = data.dosage;
      if (detailDescription) detailDescription.innerHTML = data.description;
    }

    if (!detail.id) {
      detail.id = root.id + '-detail';
    }

    items.forEach(function (item, index) {
      const trigger = item.querySelector('[data-wm-ingredient-trigger]');
      if (!trigger) return;

      const onClick = function () {
        activate(index, false);
      };

      const onKeydown = function (event) {
        let nextIndex = index;

        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
          nextIndex = (index + 1) % items.length;
        } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
          nextIndex = (index - 1 + items.length) % items.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = items.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        activate(nextIndex, true);
      };

      trigger.addEventListener('click', onClick);
      trigger.addEventListener('keydown', onKeydown);
      handlers.push({ trigger: trigger, onClick: onClick, onKeydown: onKeydown });
    });

    root.wmIngredientFocusHandlers = handlers;
    activate(0, false);
  }

  function destroy(root) {
    if (root.dataset.wmInit !== 'true') return;

    (root.wmIngredientFocusHandlers || []).forEach(function (handler) {
      handler.trigger.removeEventListener('click', handler.onClick);
      handler.trigger.removeEventListener('keydown', handler.onKeydown);
    });

    delete root.wmIngredientFocusHandlers;
    delete root.dataset.wmInit;
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll(SELECTOR).forEach(destroy);
  });
})();
